var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "thumbnail",
      rawName: "v-thumbnail:background-image",
      value: _vm.src,
      expression: "src",
      arg: "background-image"
    }],
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClick.apply(null, arguments);
      }
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };